import { render, staticRenderFns } from "./butlerDetail.vue?vue&type=template&id=72b83f2e&scoped=true&"
import script from "./butlerDetail.vue?vue&type=script&lang=js&"
export * from "./butlerDetail.vue?vue&type=script&lang=js&"
import style0 from "./butlerDetail.vue?vue&type=style&index=0&id=72b83f2e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b83f2e",
  null
  
)

export default component.exports